import { User, Workorder } from '@certhon/models';
import { PlangroupFilter } from './PlangroupFilter';
import { TechnicianSelector } from './TechnicianSelector';

interface DayPlanningFiltersProps {
  /** Map of technician ID to their workorders */
  workordersByTech: Map<number, Workorder[]>;
  /** Currently selected technician ID (null = all technicians) */
  selectedTechId: number | null;
  /** Callback when technician selection changes */
  onSelectTech: (techId: number | null) => void;
  /** Map of user ID to user details */
  userMap: Map<number, User>;
  /** Whether the current user can edit day planning (admin mode) */
  canEdit: boolean;
}

/**
 * Day Planning Filters Component
 *
 * Provides plangroup filtering and technician selection controls
 * for admin users. Shows both team filter and technician tabs.
 */
export function DayPlanningFilters({
  workordersByTech,
  selectedTechId,
  onSelectTech,
  userMap,
  canEdit,
}: DayPlanningFiltersProps) {
  // Only render filters if user has admin access
  if (!canEdit) {
    return null;
  }

  return (
    <div className="mb-4 flex items-center gap-2">
      <PlangroupFilter />
      {workordersByTech.size > 0 && (
        <div className="min-w-0 flex-1">
          <TechnicianSelector
            workordersByTech={workordersByTech}
            selectedId={selectedTechId}
            onSelect={onSelectTech}
            userMap={userMap}
          />
        </div>
      )}
    </div>
  );
}
